import { render, staticRenderFns } from "./WSServerComponent.vue?vue&type=template&id=5e7d397f&scoped=true"
import script from "./WSServerComponent.vue?vue&type=script&lang=js"
export * from "./WSServerComponent.vue?vue&type=script&lang=js"
import style0 from "./WSServerComponent.vue?vue&type=style&index=0&id=5e7d397f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7d397f",
  null
  
)

export default component.exports